import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const autohelden = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Partnerwerkstaetten in Ihrer Naehe": "Autohelden Werkstätten in Ihrer Nähe",
      hero: {
        title: "<strong>Willkommen bei der Werkstatt-Buchung von {{organization}}</strong>",
        subtitle: null,
      },
      layout: {
        backText: "Zurück zu fahrzeuge-autohelden.de",
        navbar: {
          partnerLogo: {
            alt: "Autohelden",
          },
        },
      },
      linkToHome: "https://werkstatt.repareo.de/partner/autohelden",
    },
  },
};
